"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportError = void 0;
var tslib_1 = require("tslib");
var TransportError = /** @class */ (function (_super) {
    tslib_1.__extends(TransportError, _super);
    function TransportError(status, url, error) {
        var _this = _super.call(this) || this;
        _this.status = status;
        _this.url = url;
        _this.error = error;
        _this.name = _this.constructor.name;
        return _this;
    }
    return TransportError;
}(Error));
exports.TransportError = TransportError;
//# sourceMappingURL=transport-error.js.map